export default "__VITE_ASSET__Dseye23w__"